module.exports = __webpack_public_path__ + "assets/img/37_1034_big.aa56e315.jpg";